



import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { emailValidation, CodeValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { postForgotUsername } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';

interface Error {
	code: number;
	field: string;
	message: string;
}

@Component({
	validations: {
		email: emailValidation.validations,
		pin: CodeValidation.validations(4),
	},
})
export default class ForgotUsername extends Vue {
	email = '';

	pin = '';

	recoverBtn = true;

	pinDoesNotMatchEmail = false;

	get emailErrors(): string[] {
		return emailValidation.errors(this);
	}

	get pinErrors(): string[] {
		if (this.pinDoesNotMatchEmail) {
			return ['Invalid Pin'];
		}

		return CodeValidation.errors(this, 'pin', '4');
	}

	async recoverUsername(): Promise<void> {
		this.$v.$touch();

		if (!this.$v.$invalid) {
			await this.$store.dispatch('clearError');
			this.pinDoesNotMatchEmail = false;
			this.recoverBtn = false;

			try {
				await postForgotUsername({
					email: this.email,
					pin: this.pin,
				});

				this.$router.push({ name: 'usernameReminder' });
			} catch (error) {
				let errorMessage = 'An unknown error has occurred.';

				const responseStatusCode: number = error.response?.data?.error?.code ?? 500;
				const errors: Error[] | null = error.response?.data?.error?.errors ?? null;

				if (responseStatusCode === 422 && errors && errors.length) {
					const errorObject: Error = errors[0];
					errorMessage = errorObject.message;

					// Check if error response if for invalid pin
					if (errorObject.field === 'pin') {
						this.pinDoesNotMatchEmail = true;
					}
				}

				await this.$store.dispatch('showError', errorMessage);
				this.recoverBtn = true;
			}
		}
	}
}
